<script setup lang="ts">
import { adminAllOffMicro } from "../../../../actions/AdminAllOffMicro";
import { locale } from "../../../../locale";
import BasePopoverItem from "./BasePopoverItem.vue";
const props = defineProps<{
  close: () => void;
}>();

const alloffmicro = () => {
  adminAllOffMicro();
  props.close();
};
</script>
<template>
  <BasePopoverItem :text="locale.allOffMicro" @click.stop="alloffmicro">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 8.4V9.2C5 10.6852 5.39981 12.0498 6.4 13.1C7.40019 14.1502 8.58551 14.8 10 14.8M10 14.8C11.4145 14.8 12.7498 14.0502 13.75 13C13.7873 12.9608 13.9563 13.081 13.9924 13.0408M10 14.8V18M15 8.4V9.2C15 9.72364 14.9843 10.0052 14.85 10.5M10 18H8.75M10 18H11.4444M3 2L11.7912 10.8273M17 16L13.9924 13.0408M7.8254 6.84524V9.2C7.8254 10.5255 8.73763 11.6 10 11.6C10.6643 11.6 11.3735 11.3024 11.7912 10.8273M11.7912 10.8273L13.607 12.6506L13.9924 13.0408M12.15 7.77778V4.4C12.15 3.05 11.1389 2 10 2C8.75 2 8.2 3 8.04062 3.38197"
        stroke="#ECECEC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </BasePopoverItem>
</template>
